<template>
  <div class="items-start flex mr-4">
    <div class="dropdown">
      <button
        type="button"
        data-toggle="dropdown"
        class="space-x-3 text-blackest rounded-full bg-grey-lighter py-4 px-4 focus:outline-hidden"
      >
        <span class="font-bold">{{ category }}</span>
        <span class="caret" />
      </button>
      <ul class="dropdown-menu">
        <li
          v-for="category in categories"
          :key="category"
          @click="select(category)"
          class="px-4 py-1 cursor-pointer hover:bg-primary hover:text-white"
        >
          {{ category }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { categories } from "@/lib/ListingFilters"

export default {
  name: "Listings.CategorySelector",
  methods: {
    select(category) {
      this.selectCategory(category)
    },
    ...mapActions("filter", ["selectCategory", "mergeFilter"]),
  },
  computed: {
    ...mapState("filter", ["filters"]),
    ...mapState("filter", {
      category: ({ filters }) => filters.category,
    }),
    categories() {
      return Object.keys(categories)
    },
  },
}
</script>
